import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3;

import * as React from 'react';
import styled from 'styled-components';
import { Avatar, Button } from '@ifixit/toolbox';
import { _js } from '@ifixit/localize';
import { color } from '@core-ds/primitives';
var Container = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n   display: flex;\n   justify-content: space-between;\n"])));
var Link = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n   display: flex;\n"])));
var Name = styled.h3(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n   margin: 0 0 0 8px;\n   font-size: 14px;\n   font-weight: bold;\n   line-height: 24px;\n   color: ", ";\n"])), color.gray[600]);

var Author = function Author(_ref) {
  var author = _ref.author,
      reviewsUrl = _ref.reviewsUrl;
  var name = author.name,
      avatar = author.avatar,
      url = author.url,
      userid = author.userid,
      canEdit = author.canEdit;
  return /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Link, {
    href: url
  }, /*#__PURE__*/React.createElement(Avatar, {
    src: avatar,
    size: 28
  }), /*#__PURE__*/React.createElement(Name, null, name)), canEdit && reviewsUrl && /*#__PURE__*/React.createElement("a", {
    href: "".concat(reviewsUrl, "?userid=").concat(userid)
  }, /*#__PURE__*/React.createElement(Button, {
    size: "small"
  }, _js('Edit'))));
};

export default Author;